module.exports = __webpack_public_path__ + "img/toilet.9b6ea6d0.svg";